import React from "react";
import { useNavigate } from "react-router-dom";
import "./ProfileCard.css";
import profileImage from "../assets/profile.jpeg"; // Import the image from the new location
import {
  FaPhone,
  FaEnvelope,
  FaCommentDots,
  FaCog,
  FaSignOutAlt,
} from "react-icons/fa";

export default function ProfileCard({ onClose }) {
  const navigate = useNavigate();

  const handleClick = (action) => {
    alert(`You clicked: ${action}`);
  };

  const handleSignOut = () => {
    navigate("/sign-out");
    if (onClose) onClose();
  };

  return (
    <div className="profile-card">
      <div className="profile-header">
        <img
          src={profileImage}
          alt="Profile"
          className="profile-image"
        />
        <div>
          <h2 className="profile-name">Mr. Pujitha Silva</h2>
          <p className="profile-role">Wildlife Officer</p>
          <p className="profile-time">Last time: Today, 2.03 pm</p>
        </div>
      </div>

      <div className="section">
        <p className="section-label">Emergency Contact:</p>
        <div className="icons">
          <FaPhone onClick={() => handleClick("Phone")} />
          <FaEnvelope onClick={() => handleClick("Email")} />
        </div>
      </div>

      <hr />

      <div className="menu">

        <div className="menu-item" onClick={() => handleClick("Settings")}>
          <FaCog className="menu-icon" />
          <span>Settings</span>
        </div>
        <div className="menu-item" onClick={handleSignOut}>
          <FaSignOutAlt className="menu-icon" />
          <span>Sign Out</span>
        </div>
      </div>

      <button className="close-btn" onClick={onClose}>×</button>
    </div>
  );
}
